import { CruiseModel, useGetCruise } from 'api-hooks/cruise';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import CreateSelectComponent from 'components/elements/create-select-component';
import { camelizeKeys } from 'humps';
import { useRouter } from 'next/router';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import useNavigation from './use-navigation';

export default function useGetCruiseShips(cruiseIdName) {
  const [cruiseShips, setCruiseShips] = React.useState<Option[]>([]);
  const { control } = useFormContext();
  const { navigate } = useNavigation();
  const { asPath } = useRouter();

  const cruiseId = useWatch({
    control,
    name: cruiseIdName,
  });

  const onClickCreate = React.useCallback(() => {
    PreviousNavigation.set(asPath);
    navigate(NavigationRoutes.CruisesView, { id: cruiseId, editable: true });
  }, [asPath, cruiseId, navigate]);

  const { data } = useGetCruise(
    {
      id: cruiseId,
    },
    {
      enabled: !!cruiseId,
      onSuccess: (data) => {
        if (data.data) {
          const result: CruiseModel = camelizeKeys(data.data) as CruiseModel;
          setCruiseShips(
            result.cruiseShips
              .map((item) => ({
                id: item.id,
                label: `${item.name}`,
                disabled: false,
              }))
              .concat([
                {
                  id: 'action_create',
                  label: (
                    <div
                      style={{
                        padding: '8px 16px',
                      }}
                      key="action_create"
                    >
                      <CreateSelectComponent
                        onCreate={onClickCreate}
                        label="Create New"
                      />
                    </div>
                  ) as unknown as string,
                  disabled: true,
                },
              ]),
          );
        }
      },
    },
  );

  return {
    data,
    cruiseShips,
  };
}
